import * as Sentry from "@sentry/browser";
import { User, StripeSubscription } from "../docuclipper/DocuclipperTypes";
import {
    identifyPostHogUser,
    setPostHogSubscription,
    resetPostHog,
} from "./posthog";

const isProdLike = () =>
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_POSTHOG_FORCE === "1";

export const setSentryUserContext = (user: User | null) => {
    identifyPostHogUser(user);

    if (!isProdLike()) return;

    if (!user) {
        Sentry.setUser(null);
        return;
    }

    Sentry.setUser({
        id: user.id?.toString(),
        email: user.email,
    });
};

export const setSentrySubscriptionTags = (subscription: StripeSubscription | null) => {
    setPostHogSubscription(subscription);

    if (!isProdLike()) return;

    Sentry.setTag("subscription.status", subscription?.status || "none");


};

export const clearSentryContext = () => {
    resetPostHog();
    if (!isProdLike()) return;
    Sentry.setUser(null);
};
